import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen bg-ink grid place-items-center label-mono text-zinc-400" data-testid="auth-loading">Verifica sessione…</div>;
  }
  return user ? children : <Navigate to="/admin/login" replace />;
};

function App() {
  return (
    <div className="App">
      <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
